import { default as MuiStep } from '@mui/material/Step';

/**
 * Step represents a single step within a Stepper.
 *
 * Demos:
 *
 * - [Stepper](https://unify.workiva.org/components/stepper?tab=code)
 *
 * API:
 *
 * - [Step API](https://unify.workiva.org/components/stepper?tab=props#step)
 */
export const Step = MuiStep;
export { type StepProps, stepClasses } from '@mui/material/Step';
